import { BACKEND_URL as RESOLVED_BACKEND } from "@/lib/api";

export const APP_NAME = process.env.REACT_APP_NAME || "VELACIN";
export const APP_TAGLINE = process.env.REACT_APP_TAGLINE || "HR × PM Suite";
export const BACKEND_URL = RESOLVED_BACKEND;

// Turn a possibly-relative avatar/file URL from the API into an absolute one.
export function absUrl(u) {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return `${BACKEND_URL}${u}`;
}
